/**/
/* Rommá optimalizált belépési pont, hogy mindent elfedjünk azok elől, akik nincsenek bejelentkezve.
/* Semmilyen sensitive adat nem kerülhet ki, mint pl.: lehetséges route-ok.
/*
/* Ha bármilyen logika kell a belépési utáni részhez, azt az "init"-be kell rakni.
/**/

// Nem a common/Cookie-t használjuk, mert az egy ilyen egyszerű kéréshez túl nagy és nincs rá szükség.
import hasCookieByName from '@common/Cookie/utils/hasCookieByName'

import './main.scss'

(async function IIFE (): Promise<void> {
// Ha van már neki stoc cookie-ja, akkor mutassuk a dashboard-ot.
if (hasCookieByName(document.cookie, 'corp:stoc')) {
  const { default: stoc } = await import(
    /* webpackChunkName: "stoc" */
    './stoc'
  )

  // A stoc-ot itt vizsgáljuk, nem az init-ben, mert simán hazudhat magának egyet, és akkor már megkapná az egész init-et.
  const isValid = await stoc.isValid()

  // Ha már nem él a STOC, akkor dobjuk el.
  if (!isValid) {
    stoc.delete()
    window.location.href = '/'

    return
  }

  // ------------------

  const { default: init } = await import(
    /* webpackChunkName: "init" */
    './init'
  )

  init()
}
// Nincs stoc, mehet a bejelentkezés.
else {
  const { default: Auth } = await import(
    /* webpackChunkName: "auth" */
    './components/Auth/Auth'
  )

  document.body.appendChild(Auth())
}
})()
